/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Use_Legacy_ButtonInputs */

const en_timeline_use_legacy_button = /** @type {(inputs: Timeline_Use_Legacy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Legacy Timeline`)
};

const fr_timeline_use_legacy_button = /** @type {(inputs: Timeline_Use_Legacy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliser la chronologie heritee`)
};

const de_timeline_use_legacy_button = /** @type {(inputs: Timeline_Use_Legacy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legacy-Zeitleiste verwenden`)
};

const it_timeline_use_legacy_button = /** @type {(inputs: Timeline_Use_Legacy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa la cronologia legacy`)
};

const ru_timeline_use_legacy_button = /** @type {(inputs: Timeline_Use_Legacy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте устаревшую временную шкалу.`)
};

const es_timeline_use_legacy_button = /** @type {(inputs: Timeline_Use_Legacy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar la línea de tiempo heredada`)
};

const zh_cn2_timeline_use_legacy_button = /** @type {(inputs: Timeline_Use_Legacy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用旧版时间线`)
};

const ja_timeline_use_legacy_button = /** @type {(inputs: Timeline_Use_Legacy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レガシータイムラインを使用する`)
};

const hi_timeline_use_legacy_button = /** @type {(inputs: Timeline_Use_Legacy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लेगेसी टाइमलाइन का उपयोग करें`)
};

const pt_pt2_timeline_use_legacy_button = /** @type {(inputs: Timeline_Use_Legacy_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar a linha do tempo legada`)
};

/**
* | output |
* | --- |
* | "Use Legacy Timeline" |
*
* @param {Timeline_Use_Legacy_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_use_legacy_button = /** @type {((inputs?: Timeline_Use_Legacy_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Use_Legacy_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_use_legacy_button(inputs)
	if (locale === "de") return de_timeline_use_legacy_button(inputs)
	if (locale === "it") return it_timeline_use_legacy_button(inputs)
	if (locale === "ru") return ru_timeline_use_legacy_button(inputs)
	if (locale === "es") return es_timeline_use_legacy_button(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_use_legacy_button(inputs)
	if (locale === "ja") return ja_timeline_use_legacy_button(inputs)
	if (locale === "hi") return hi_timeline_use_legacy_button(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_use_legacy_button(inputs)
	return en_timeline_use_legacy_button(inputs)
});